import { Injectable } from "@angular/core";
import { IID_ESPLETATO_OK_CHECKLIST_GISFO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDEspletatoOkChecklistGISFOStore } from "./espletatoOkChecklistGISFO.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ESPLETATO_OK_CHECKLIST_GISFO)
export class IIDEspletatoOkChecklistGISFOQuery extends AbstractInterfaceDataQuery<IID_ESPLETATO_OK_CHECKLIST_GISFO> {

  constructor(protected store: IIDEspletatoOkChecklistGISFOStore) {
    super(store);
  }
}
